export type Locale = (typeof locales)[number];

export const locales = ["en", "pt", "es", "hi"] as const;
export const defaultLocale: Locale = "en";

export const isLocale = (value: string | undefined | null): value is Locale =>
  Boolean(value && (locales as readonly string[]).includes(value));
